const ALLOWED_TAGS = new Set(['STRONG', 'EM', 'UL', 'OL', 'LI', 'A', 'BR', 'P']);
const STRIP_CONTENT_TAGS = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEMPLATE']);
const ALLOWED_ATTRS_PER_TAG: Record<string, string[]> = {
  A: ['href', 'target', 'rel'],
};

function isSafeUrl(url: string): boolean {
  const trimmed = url.trim().toLowerCase();
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://') || trimmed.startsWith('mailto:')) {
    return true;
  }
  return false;
}

export function sanitizeHtml(input: string): string {
  if (typeof DOMParser === 'undefined') {
    return escapeHtml(input);
  }
  const doc = new DOMParser().parseFromString(`<div>${input}</div>`, 'text/html');
  const root = doc.body.firstElementChild;
  if (!root) return '';
  walkAndClean(root);
  return root.innerHTML;
}

function walkAndClean(el: Element): void {
  const children = Array.from(el.children);
  for (const child of children) {
    if (!ALLOWED_TAGS.has(child.tagName)) {
      // Tags whose content must be stripped entirely (script, style, etc.)
      if (STRIP_CONTENT_TAGS.has(child.tagName)) {
        child.replaceWith(doc().createTextNode(''));
      } else {
        // For other disallowed tags, keep their text content but drop the tag
        const text = doc().createTextNode(child.textContent ?? '');
        child.replaceWith(text);
      }
      continue;
    }
    const allowed = ALLOWED_ATTRS_PER_TAG[child.tagName] ?? [];
    for (const attr of Array.from(child.attributes)) {
      if (!allowed.includes(attr.name.toLowerCase())) {
        child.removeAttribute(attr.name);
      }
    }
    if (child.tagName === 'A') {
      const href = child.getAttribute('href');
      if (!href || !isSafeUrl(href)) {
        child.removeAttribute('href');
      } else {
        child.setAttribute('target', '_blank');
        child.setAttribute('rel', 'noopener noreferrer');
      }
      // Always set target and rel for security even when href is unsafe/absent
      if (!child.getAttribute('target')) child.setAttribute('target', '_blank');
      if (!child.getAttribute('rel')) child.setAttribute('rel', 'noopener noreferrer');
    }
    walkAndClean(child);
  }
}

function doc(): Document {
  return globalThis.document ?? new DOMParser().parseFromString('<!doctype html><html><body></body></html>', 'text/html');
}

export function escapeHtml(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
